import config from 'config';

const excludeFromByoTag = config.get('public.productTags.excludeFromByo');
const comingSoonTag = config.get('public.productTags.comingSoon');
const oneSizeLinkedProducts = config.get(
  'public.productTags.oneSizeLinkedProducts'
);

export function applyByoFilters(filters = {}, filterLinkedProducts = false) {
  const { excludeTagIds = [] } = filters;
  return {
    ...filters,
    excludePreorderProducts: true,
    excludeTagIds: [...excludeTagIds, excludeFromByoTag, comingSoonTag],
    ...(filterLinkedProducts && { excludeFpls: [oneSizeLinkedProducts] }),
  };
}
